<page-header
    [icon]="['QA', 'READABILITY_CHECKER'] | monIcons"
    [header]="'Readability Checker' | translate"
    [subHeader]="subheaderTranslation">
</page-header>
<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="row">
            <div class="col-48 col-md-30">
                <label for="readability_text" class="tw-sr-only">{{ 'Type in or paste text to be analyzed' | translate }}</label>
                <textarea id="readability_text"
                        class="form-control"
                        name="readability_text"
                        [placeholder]="'Type in or paste text to be analyzed' | translate"
                        [(ngModel)]="textToCheck"
                        rows="16"
                        required>
                </textarea>
                @if (textToCheck && textToCheck.length > maxCharacters) {
                    <div class="invalid-feedback block">
                        {{ maxCharactersErrorMessage }}
                    </div>
                }
                <div class="text-center mt-1">
                    <button class="btn btn-border-radius btn-secondary w-100"
                            type="button"
                            (click)="calculateReadability()"
                            [disabled]="!textToCheck || loading || (textToCheck && textToCheck.length > maxCharacters)"
                            data-test="calculate-readability-button"
                    >
                        <span [ngClass]="{'fas fa-spinner fa-spin fa-fw ': loading}" aria-hidden="true"></span>
                        <span>{{ 'Calculate Readability Score' | translate }}</span>
                    </button>
                </div>
            </div>

            <!-- score section -->
            <div class="col-48 col-md-18">
                <div class="text-center p-2">
                    <p class="font-size-1-5 text-secondary-4 mb-4">{{ 'Readability Level' | translate }}</p>

                    @if (loading) {
                        <div class="text-center">
                            <span class="fas fa-spinner fa-spin fa-2x text-secondary" aria-hidden="true"></span>
                        </div>
                    } @else if (error) {
                        <h3 class="invalid-feedback block font-size-1-1">
                            {{ error }}
                        </h3>
                    } @else if (readabilityLevel) {
                        <h3>
                            {{ readabilityScore !== null ? readabilityScore + ' - ' : '' }}{{ readabilityLevel | translateReadability:domain.features.readability_test }}
                        </h3>
                    } @else {
                        <h4 class="text-grey">{{ 'Calculate score to see results' | translate }}</h4>
                    }
                </div>
            </div>
        </div>
    </div>
</div>